const EDUCATIONS = [
  {
    id: "naver-boostcamp",
    title: "Naver Boostcamp 6th",
    subtitle: "풀스택 프로그램 수료",
    duration: "2021.07 - 2021.12",
    image: "./boostcamp.png",
  },
  {
    id: "hanyang",
    title: "한양대학교 경제학부 (ERICA)",
    subtitle: "경제학부 학사 졸업",
    duration: "2014.03 - 2022.08",
    image: "./hanyang-univ.png",
  },
  {
    id: "kobe",
    title: "고베대학교 경제학부 (Exchange)",
    subtitle: "경제학부 교환학생",
    duration: "2019.04 - 2019.09",
    image: "./kobe-univ.png",
  },
];

export default EDUCATIONS;
